import { Controller } from '@hotwired/stimulus'

const SYSTEMS = ['skin', 'heent', 'chest', 'heart', 'abdomen', 'neuro', 'rectal', 'gu']

export default class extends Controller {
  static targets = [
    'systolic', 'diastolic', 'heartRate', 'respiratoryRate', 'temperature',
    'height', 'weight', 'bmi', 'leftVision', 'rightVision'
  ]

  calculateBmi() {
    const height = parseFloat(this.heightTarget.value)
    const weight = parseFloat(this.weightTarget.value)

    if (height > 0 && weight > 0) {
      const heightM = height / 100
      this.bmiTarget.value = (weight / (heightM * heightM)).toFixed(2)
    } else {
      this.bmiTarget.value = ''
    }
  }

  copyFromScreening(event) {
    const d = event.currentTarget.dataset
    const fill = (target, key) => { if (d[key] !== undefined && d[key] !== '') target.value = d[key] }

    fill(this.systolicTarget, 'systolic')
    fill(this.diastolicTarget, 'diastolic')
    fill(this.heartRateTarget, 'heartRate')
    fill(this.respiratoryRateTarget, 'respiratoryRate')
    fill(this.temperatureTarget, 'temperature')
    fill(this.heightTarget, 'height')
    fill(this.weightTarget, 'weight')
    fill(this.bmiTarget, 'bmi')
    fill(this.leftVisionTarget, 'leftVision')
    fill(this.rightVisionTarget, 'rightVision')
  }

  copyRosFromScreening(event) {
    const btn = event.currentTarget
    const miscData = JSON.parse(btn.dataset.rosMisc || '[]')
    const specData = JSON.parse(btn.dataset.rosSpec || '{}')

    // Fill specific rem text areas
    SYSTEMS.forEach(system => {
      const val = specData[system]
      if (val == null || val === '') return
      const ta = this.element.querySelector(`textarea[name*="soap_physical_examination_specific_attributes"][name*="${system}_rem"]`)
      if (ta) ta.value = val
    })

    // Copy checkboxes from the first (only) screening entry
    const entry = miscData[0]
    if (!entry) return

    SYSTEMS.forEach(system => {
      const codes = [entry[system]].flat().filter(Boolean)
      const checkboxes = this.element.querySelectorAll(`input[type="checkbox"][name*="${system}_id"]`)
      checkboxes.forEach(cb => {
        cb.checked = codes.includes(cb.value)
        cb.dispatchEvent(new Event('change', { bubbles: true }))
      })
    })
  }
}
